import Avatar from "app/containers/Features/components/Avatar";
import React from "react";

interface StatusSelectionButtonProps {
  className?: string;
  label: string;
  textClassName?: string;
  icon?: React.ReactNode;
  selectedIcon?: React.ReactNode;
  selectedLabel?: string;
  showAvatar?: boolean;
  avatarColor?: string;
  textColor?:string
}

const StatusSelectionButton: React.FC<StatusSelectionButtonProps> = ({
  className,
  label,
  icon,
  textClassName,
  selectedIcon,
  selectedLabel,
  showAvatar,
  avatarColor,
  textColor
}) => {
  return (
    <>
      <div className={`flex items-center gap-2 ${className}`}>
        {icon}
        <span className={`text-nowrap overflow-hidden text-ellipsis `}>
          {label}
        </span>
      </div>

      {showAvatar && selectedLabel ? (
        <Avatar name={selectedLabel as string} color={avatarColor} />
      ) : (
        <div className={`flex items-center gap-2 `}>
          {selectedIcon}
          <span
            className={`text-nowrap overflow-hidden text-ellipsis ${className} ${textClassName}`}
            style={{color:textColor}}
          >
            {selectedLabel}
          </span>
        </div>
      )}
     
    </>
  );
};

export default StatusSelectionButton;
